import Api from '@/api/Api'
import store from '../store'

export default {

  async getAll (param) {
    return store.dispatch('checkResponseApi', await Api().get('pos/bills' + param))
  },

  async getSingle (data) {
    return store.dispatch('checkResponseApi', await Api().get('pos/bill?bi_id=' + data.bi_id))
  },

  async insert (data) {
    let options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().post('pos/bill', data, options))
  },

  async refundInsert (data) {
    let options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().post('pos/bill/refund', data, options))
  },

  async getLatestCode (params) {
    return store.dispatch('checkResponseApi', await Api().get('/pos/bill/latest_code', { params }))
  },

  async getUsedCode (params) {
    return store.dispatch('checkResponseApi', await Api().get('/pos/bill/used_queue_codes', { params }))
  },

  async sentReceiptEmail (posbiId, data) {
    let options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().post(`pos/bill/${posbiId}/email`, data, options))
  },
}



// WEBPACK FOOTER //
// ./src/api/PosBillService.js